export enum DriveAPICredentialsActionTypes {
    SET_DRIVE_API_CREDENTIALS = "SET_DRIVE_API_CREDENTIALS",
    CLEAR_DRIVE_API_USER_CREDENTIALS = "CLEAR_DRIVE_API_USER_CREDENTIALS",
    CLEAR_DRIVE_API_CREDENTIALS = "CLEAR_DRIVE_API_CREDENTIALS"
}